import { render, staticRenderFns } from "./RecipePage.vue?vue&type=template&id=57198b8b&scoped=true"
import script from "./RecipePage.vue?vue&type=script&lang=js"
export * from "./RecipePage.vue?vue&type=script&lang=js"
import style0 from "./RecipePage.vue?vue&type=style&index=0&id=57198b8b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57198b8b",
  null
  
)

export default component.exports